import { ondeOPastejoGeraValorContent as c } from "./content";
import { ReactComponent as BackIcon } from "../../../assets/svg/icons/back.svg";

export function Values() {
  const headingParts = c.heading.split(c.headingAccentWord);
  const headingLead = (headingParts[0] ?? "").replace(/\n+$/, "");
  return (
    <section className="home-page-v2__section home-page-v2__section--valor">
      <div className="home-page-v2__section-inner home-page-v2__valor-layout">
        <h2 id="onde-valor-heading" className="home-page-v2__valor-heading">
          <span className="home-page-v2__valor-heading-line">{headingLead}</span>
          <span className="home-page-v2__valor-heading-accent">{c.headingAccentWord}</span>
        </h2>
        <div className="home-page-v2__valor-copy">
          <p>{c.body}</p>
          <br/>
          <ul className="pill-list">
            {c.benefits.map((text) => (
              <li key={text}>
                <div className="home-page-v2__pill-list-icon" aria-hidden>
                  <BackIcon width={20} height={20} />
                </div>
                <span>
                  {text}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
